import React from 'react'

import { Box } from '@mui/system'

export const Card = ({ children, sx, ...props }) => {
    return (
        <Box sx={{ p: 2, background: 'white', borderRadius: 2, ...sx }}>
            {children}
        </Box>
    )
}
